const AzureSsoRedirect = () => null;

export default AzureSsoRedirect;
